import { Box, Grid, IconButton, MenuItem, Paper } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import MaterialTable from "material-table";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { getBuildingSettingOption } from "../../../api/buildingSettingApi";
import {
    checkStatusFinance,
    getQueueFinance,
    getQueueRoom,
    updateCashierQueuePaymentById,
} from "../../../api/queueApi";
import { useClassApp } from "../../../styles/useClassApp";
import SelectDropOtions from "../../components/SelectDropOtions";
import PayFormMed from "./components/PayFormMed";
import PaymentActions from "./components/PaymentActions";
import SwitchComponentActionsForm from "./components/SwitchComponentActionsForm";
import { columnsTablePayAll, optionTables } from "./helpers/paymentEvtOption";
import Color from "../../../styles/Color";
import { io } from "socket.io-client";
import { swalCondition } from "../../../utils/swalHelper";
import { useSelector } from "react-redux";
import InputDatePicker from "../../components/InputDatePicker";
import moment from "moment";

function PaymentManagement() {
    const initialStateActionDropdown = {
        building: "",
        floor: "",
        room: "",
        roomObj: {},
    };
    const classes = useClassApp();

    // ref
    const tableRef = useRef(null);
    const controllerRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // component state
    const [socketIO, setSocketIO] = useState(null);
    const [tabs, setTabs] = useState(0);
    const [tableOptions, setTableOptions] = useState(optionTables);
    const [option, setOption] = useState({ building: [], floor: [] });
    const [modalToggle, setModalToggle] = useState({ isOpen: false, type: "", data: {} });
    const [modalFormActions, setModalFormActions] = useState({ isOpen: false, type: "" });
    const [drugReceptionRoom, setDrugReceptionRoom] = useState([]);
    const [isAllactionDD, setIsAllactionDD] = useState(initialStateActionDropdown);
    const [requestFinance, setRequestFinance] = useState({});
    const [totalFinance, setTotalFinance] = useState({});
    const [datePick, setDatePick] = useState({ start: new Date(), end: new Date() });

    // change tab
    const handleOnChangeTabs = useCallback(
        async tabIdx => {
            setTabs(tabIdx);
            if (tabIdx === 0) {
                setRequestFinance({ ...requestFinance, statusRoom: "0" });
            } else if (tabIdx === 1) {
                setRequestFinance({ ...requestFinance, statusRoom: "1" });
            } else if (tabIdx === 2) {
                setRequestFinance({ ...requestFinance, statusRoom: "2" });
            } else if (tabIdx === 3) {
                setRequestFinance({ ...requestFinance, statusRoom: "3" });
            } else if (tabIdx === 4) {
                setRequestFinance({ ...requestFinance, statusRoom: "4" });
            }
            if (isAllactionDD.room) {
                tableRef.current.onQueryChange({ page: 0 });
            }
        },
        [requestFinance, isAllactionDD.room],
    );

    // fetch building setting option
    const fetchBuildingSettingOption = useCallback(async signal => {
        try {
            const buildingSettingOption = await getBuildingSettingOption(signal);
            if (buildingSettingOption) {
                setOption(currentState => ({
                    ...currentState,
                    building: buildingSettingOption?.buildingOption,
                    floor: buildingSettingOption?.floorOption,
                }));
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // fetch examination room
    const fetchRoom = useCallback(async (building = null, floor = null) => {
        try {
            const createBody = {
                builingId: building ? building : 0,
                floorId: floor ? floor : 0,
                statusRoom: "2",
            };
            const res = await getQueueRoom(createBody);
            if (res) {
                setDrugReceptionRoom(res?.data);
                return res?.data;
            }
        } catch (error) {
            console.dir(error);
        }
    }, []);

    // fetch finance queue
    const fetchQueueFinance = useCallback(
        async query => {
            try {
                if (!requestFinance?.statusRoom || !isAllactionDD.room) {
                    setTotalFinance({});
                    return {
                        data: [],
                        page: 0,
                        totalCount: 0,
                    };
                }
                const queryParams = {
                    page: query?.page + 1 || 1,
                    limit: query?.pageSize || 10,
                    search: query?.search || "",
                    locationCode: requestFinance?.locationCode,
                    roomId: requestFinance?.roomId,
                    statusRoom: requestFinance?.statusRoom,
                    startDate: moment(datePick?.start).format("YYYY-MM-DD"),
                    endDate: moment(datePick?.end).format("YYYY-MM-DD"),
                };
                const res = await getQueueFinance(queryParams, controllerRef.current?.signal);
                if (res) {
                    setTotalFinance(res?.total);
                    setTableOptions(currentState => ({
                        ...currentState,
                        currentPage: query?.page,
                        pageSize: query?.pageSize || 10,
                        totalData: res?.pagination?.totalData || 0,
                        order: query?.orderBy?.field || "appointmentId",
                        direction: query?.orderBy?.field ? query?.orderDirection : "asc",
                    }));
                    return {
                        data: res?.data || [],
                        page: query?.page || 0,
                        totalCount: res?.pagination?.totalData || 0,
                    };
                }
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            } catch (error) {
                console.dir(error);
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            }
        },
        [requestFinance, isAllactionDD.room, datePick],
    );

    const handleOnchangeDropdown = useCallback(
        async (type = "", value = "") => {
            if (type === "building") {
                setIsAllactionDD({ ...isAllactionDD, building: value, floor: "", room: "" });
                setRequestFinance({
                    locationCode: "",
                    roomId: "",
                    statusRoom: "",
                });
                setTabs(0);
                tableRef.current.onQueryChange({ page: 0 });
            } else if (type === "floor") {
                setIsAllactionDD({ ...isAllactionDD, floor: value, room: "" });
                const rooms = await fetchRoom(isAllactionDD?.building, value);
                setRequestFinance({
                    locationCode: rooms[0]?.Floor?.locationCode,
                    roomId: "",
                    statusRoom: "",
                });
                setTabs(0);
                tableRef.current.onQueryChange({ page: 0 });
            } else if (type === "room") {
                setIsAllactionDD({
                    ...isAllactionDD,
                    room: value,
                    roomObj: drugReceptionRoom?.find(room => room?.roomId === value),
                });
                setRequestFinance({
                    locationCode: drugReceptionRoom[0]?.Floor?.locationCode,
                    roomId: value,
                    statusRoom: "0",
                });
                setTabs(0);
                tableRef.current.onQueryChange({ page: 0 });
            }
        },
        [isAllactionDD, fetchRoom, drugReceptionRoom],
    );

    // for click actions เป็น modal แรก
    const handleToggleModalChangeStatus = useCallback(item => {
        setModalToggle({ isOpen: true, type: "actions", data: item });
    }, []);

    // for click actions เป็น modal สอง
    const handleToggleModalFormActions = useCallback(type => {
        setModalToggle(prev => ({ ...prev, isOpen: false }));
        setModalFormActions({ isOpen: true, type: type });
    }, []);

    // update status room
    const updateDetailPatient = useCallback(
        async value => {
            try {
                const isUpdate = await updateCashierQueuePaymentById(
                    value?.cashierQueueId,
                    value,
                    controllerRef.current?.signal,
                );
                if (isUpdate) {
                    if (modalToggle.type !== "med") {
                        socketIO.emit("update-cashier-queue", {
                            type: "update-from-payment-management",
                            CashierStatus: value?.CashierStatus,
                            QueueNo: modalToggle.data?.QueueNo,
                        });
                    }
                    tableRef.current.onQueryChange();
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [socketIO, modalToggle],
    );

    // check status finance before update
    const checkCallingQueueStatus = useCallback(
        async value => {
            try {
                const queryParams = {
                    statusRoom: value?.CashierStatus,
                    roomId: value?.CashierRoom,
                    cashierQueueId: value?.cashierQueueId,
                };
                const res = await checkStatusFinance(queryParams, controllerRef.current?.signal);
                if (res?.checkStatusFinance === 0) {
                    await updateDetailPatient(value);
                } else {
                    swalCondition(
                        `<div class="h3 t-text-primary">The patient is already in ${isAllactionDD?.roomObj?.name}.</div>`,
                        "",
                        {
                            iconHtml: '<i class="far fa-clock fa-lg" style="color:inherit;" ></i>',
                            iconColor: Color.primary,
                            showCancelButton: false,
                            confirmButtonColor: Color.primary,
                            cancelButtonColor: "#7C7C7C",
                            confirmButtonText: "YES",
                            customClass: {
                                icon: "border-0 t-icon-show",
                            },
                        },
                    );
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [updateDetailPatient, isAllactionDD],
    );

    // close action modal
    const handleCloseModalActionForm = useCallback(() => {
        setModalFormActions({ isOpen: false, type: "" });
        setModalToggle(prev => ({ ...prev, isOpen: true }));
    }, []);

    // click action logic
    const handleResponseActionFormModal = useCallback(
        async (result, type) => {
            const st = result?.status;
            if (st) {
                if (type === "Call") {
                    const body = {
                        CashierStatus: "1",
                        CashierRoom: isAllactionDD?.room,
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                    };
                    await checkCallingQueueStatus(body);
                } else if (type === "Selected") {
                    const body = {
                        CashierStatus: "5",
                        CashierRoom: isAllactionDD?.room,
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                    };
                    await updateDetailPatient(body);
                } else if (type === "Confirm") {
                    const body = {
                        CashierStatus: "4",
                        CashierStatusMobile: "1",
                        CashierRoom: isAllactionDD?.room,
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                    };
                    await updateDetailPatient(body);
                } else if (type === "Hold") {
                    const body = {
                        CashierStatus: "2",
                        CashierRoom: null,
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                    };
                    await updateDetailPatient(body);
                } else if (type === "Message") {
                    const body = {
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                        title: result?.title,
                        message: result?.message,
                    };
                    await updateDetailPatient(body);
                } else if (type === "Transfer") {
                    const body = {
                        CashierStatus: "0",
                        CashierRoom: null,
                        PatientLocationCode: result?.values?.floor?.locationCode,
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                        DischargeLocationName: result?.values?.floor?.locationName,
                    };
                    await updateDetailPatient(body);
                } else if (type === "Cancel") {
                    const body = {
                        CashierStatus: "3",
                        CashierRoom: isAllactionDD?.room,
                        cashierQueueId: modalToggle?.data?.cashierQueueId,
                    };
                    await updateDetailPatient(body);
                }
                setModalFormActions({ isOpen: false, type: "" });
            } else {
                handleCloseModalActionForm();
                return false;
            }
        },
        [modalToggle, isAllactionDD, updateDetailPatient, checkCallingQueueStatus, handleCloseModalActionForm],
    );

    // open action modal
    const handleToggleModalSaveDoc = useCallback(item => {
        setModalToggle({ isOpen: true, type: "med", data: item });
    }, []);

    // for close modal
    const handleCloseModal = useCallback(() => {
        setModalToggle({ isOpen: false, type: "", data: {} });
    }, []);

    // save med remark
    const handleSaveMedRemark = useCallback(
        async value => {
            const body = {
                cashierQueueId: modalToggle?.data?.cashierQueueId,
                Remark: value?.description,
            };
            await updateDetailPatient(body);
            handleCloseModal();
        },
        [modalToggle, updateDetailPatient, handleCloseModal],
    );

    // onChange start date
    const onChangeStartDate = useCallback(date => {
        setDatePick(currentState => ({ ...currentState, start: date }));
    }, []);

    // onChange end date
    const onChangeEndDate = useCallback(date => {
        setDatePick(currentState => ({ ...currentState, end: date }));
    }, []);

    // memo
    const tableColumns = useMemo(
        () =>
            columnsTablePayAll({
                handleToggleModalChangeStatus,
                handleToggleModalSaveDoc,
                tabs,
                thisMenuPermission,
            }),
        [handleToggleModalChangeStatus, handleToggleModalSaveDoc, tabs, thisMenuPermission],
    );

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        fetchBuildingSettingOption();
        return () => {
            controllerRef.current.abort();
        };
    }, [fetchBuildingSettingOption]);

    // connect socket.io
    useEffect(() => {
        let socket;
        if (isAllactionDD?.roomObj?.floorId) {
            socket = io(`${process.env?.REACT_APP_HOST_SOCKET}/cashier-queue`, {
                transports: ["websocket"],
            });

            socket.on("connect", () => {
                socket.emit("join-cashier-room", isAllactionDD?.roomObj?.floorId);
            });

            socket.on("display-cashier-queue", () => {
                tableRef.current.onQueryChange();
            });

            setSocketIO(socket);
        }

        return () => {
            if (isAllactionDD?.roomObj?.floorId && socket) {
                socket.off("connect");
                socket.off("join-cashier-room");
                socket.off("disconnect");
                socket.emit("leave-cashier-room");
            }
        };
    }, [isAllactionDD.roomObj, tableRef]);

    useEffect(() => {
        if (datePick.start > datePick.end) {
            setDatePick(currentState => ({ ...currentState, end: datePick.start }));
        }
        tableRef.current.onQueryChange();
    }, [datePick]);

    return (
        <div>
            <Grid container spacing={0}>
                <Grid item xs={12} className="mb-3">
                    <h1 className="t-text-primary">Payment Management</h1>
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={1} className="justify-content-lg-start mb-5 d-flex">
                        <Grid item xs={12} md={4} lg={2}>
                            <SelectDropOtions
                                key={"select_floor"}
                                options={option?.building}
                                useTheme={true}
                                onChange={value => handleOnchangeDropdown("building", value)}
                                value={isAllactionDD?.building}
                                placeholder="Select..."
                                renderOption={row => {
                                    return (
                                        <MenuItem key={"building_" + row.buildingId} value={row.buildingId}>
                                            {" "}
                                            {row.name}{" "}
                                        </MenuItem>
                                    );
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} lg={2}>
                            <SelectDropOtions
                                key={"select_room"}
                                options={option?.floor.filter(item => item?.buildingId === isAllactionDD?.building)}
                                useTheme={true}
                                onChange={value => handleOnchangeDropdown("floor", value)}
                                value={isAllactionDD?.floor}
                                placeholder="Select..."
                                renderOption={row => {
                                    return (
                                        <MenuItem key={"floor_" + row.floorId} value={row.floorId}>
                                            {" "}
                                            {row.name} {row.locationName}
                                        </MenuItem>
                                    );
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} lg={2}>
                            <SelectDropOtions
                                key={"select_room"}
                                options={drugReceptionRoom}
                                useTheme={true}
                                onChange={value => handleOnchangeDropdown("room", value)}
                                value={isAllactionDD?.room}
                                placeholder="Select..."
                                renderOption={row => {
                                    return (
                                        <MenuItem key={"room_" + row?.roomId} value={row?.roomId}>
                                            {" "}
                                            {row?.name}
                                        </MenuItem>
                                    );
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <InputDatePicker
                                label=""
                                inputProps={{
                                    className: "t-form-group-custom-shadow",
                                    style: { padding: "15px 0 15px 14px" },
                                }}
                                className="bg-white rounded"
                                style={{ marginTop: -1 }}
                                value={datePick.start}
                                onChange={onChangeStartDate}
                                size="medium"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <InputDatePicker
                                label=""
                                inputProps={{
                                    className: "t-form-group-custom-shadow",
                                    style: { padding: "15px 0 15px 14px" },
                                }}
                                className="bg-white rounded"
                                style={{ marginTop: -1 }}
                                value={datePick.end}
                                minDate={datePick.start}
                                onChange={onChangeEndDate}
                                size="medium"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} className="mb-0">
                    <div className="d-flex align-items-center" style={{ overflowX: "auto", overflowY: "hidden" }}>
                        {[
                            { title: "All", count: totalFinance?.totalCall || 0 },
                            { title: "Hold", count: totalFinance?.totalHold || 0 },
                            { title: "Finish", count: totalFinance?.totalConfirm || 0 },
                            { title: "Counter", count: totalFinance?.totalCounter || 0 },
                            { title: "Mobile", count: totalFinance?.totalMobile || 0 },
                        ].map((row, idx) => (
                            <div key={"room_" + idx} className="col-4 col-sm-3 col-lg-2 px-0">
                                <div
                                    className={`${classes.boxlistRoom} ${tabs === idx ? "active" : ""}`}
                                    onClick={() => handleOnChangeTabs(idx)}>
                                    <p className="text-typo">{`${row.title} (${row.count})`}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </Grid>
                {/* content */}
                <Grid item xs={12}>
                    <Paper elevation={1} className="t-table-custom rounded">
                        <MaterialTable
                            tableRef={tableRef}
                            title=""
                            components={{ Container: Box }}
                            options={tableOptions}
                            data={fetchQueueFinance}
                            columns={tableColumns}
                        />
                    </Paper>
                </Grid>

                {/* Modal */}
                <Grid item xs={12}>
                    <Modal show={modalToggle.isOpen} size="lg" centered onHide={handleCloseModal}>
                        <Modal.Body>
                            <div className="text-right mb-3">
                                <IconButton onClick={handleCloseModal} size="small">
                                    <Close />
                                </IconButton>
                            </div>
                            {modalToggle?.type === "actions" ? (
                                <PaymentActions onClick={handleToggleModalFormActions} />
                            ) : null}
                            {modalToggle?.type === "med" ? (
                                <PayFormMed
                                    data={modalToggle?.data}
                                    onSubmit={handleSaveMedRemark}
                                    disabled={!thisMenuPermission?.edit}
                                />
                            ) : null}
                        </Modal.Body>
                    </Modal>
                    {/* modal form actions */}
                    <Modal show={modalFormActions.isOpen} centered onHide={handleCloseModalActionForm}>
                        <Modal.Body>
                            <div className="text-right mb-3">
                                <IconButton onClick={handleCloseModalActionForm} size="small">
                                    <Close />
                                </IconButton>
                            </div>
                            <SwitchComponentActionsForm
                                type={modalFormActions.type}
                                response={handleResponseActionFormModal}
                                dataOptions={option}
                            />
                        </Modal.Body>
                    </Modal>
                </Grid>
            </Grid>
        </div>
    );
}

export default PaymentManagement;
